<template>
  <div class="infoDetails">
    <nav-bar title="消息详情"></nav-bar>
    <div class="info">
      <p>您的密码已经找回注意保密不要让其他人知道让其他人知让其他人知</p>
      <div class="bottom">
        <span>活动类型或者系统消息</span>
        <span>2月26日 15:38</span>
      </div>
    </div>
    <p class="content">
      由于订单类型可以指定处理规则和订单分录默认值，因此系统在输入订单和退货单时，会要求这些订单类型。您可以将订单周期分配至每个订单类型，以控制订单处理并提供此订单类型的默认值。
      您为订单类型定义的值可默认为分配订单类型时的订单，这取决于定义标准值规则集的方式。您可以将标准值规则集附加至订单类型。
      用户下单的环节，是指前台顾客即会员浏览商城网站进行商品的挑选并提交订单。系统提供在一定的时间范围内即在会员订单提交至后台管理员还未对订单进行确认操作这段时间内，允许会员自行修改、取消自己的订单等订单管理相关操作。
      会员订单提交到商城系统后，商城系统管理员对订单的数据信息进行确认，确认的方式通过电话联系会员进行。确认的内容主要包括会员填写的收获地址是否真实有效、商品配送相关情况。
      系统提供管理员对订单进行确认有效与无效的操作处理，无效的订单管理员可以直接取消。会员订单如果已经进行确认，将不能再进行修改。
    </p>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";

export default {
  name: "infoDetails",
  components: {
    NavBar
  }
};
</script>

<style scoped lang="less">
.infoDetails {
  width: 100%;
  height: 100%;
  padding: 15px;
  .info {
    height: 74px;
    background: rgba(255, 255, 255, 1);
    padding-top: 15px;
    p {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(33, 37, 41, 1);
      margin: 0;
      padding-bottom: 5px;
    }

    .bottom {
      display: flex;
      justify-content: space-between;

      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(158, 160, 165, 1);
      }
    }
  }
  .content {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(98, 104, 112, 1);
  }
}
</style>
